import { useMemo, useContext, useCallback } from 'react';
import { useEventFeatureBoundary } from './context/eventFeatureBoundaryContext.mjs';
import { useEventPathBoundary } from './context/eventPathBoundary.mjs';
import { EventPropertyContext } from './context/eventPropertyBoundary.mjs';
import { useLoggerContext } from './context/logger.mjs';
import { ActionType } from './models/index.mjs';
import useReferenceSafeObject from './utils/useReferenceSafeObject.mjs';

const logVersion = "2.0";
const useEventLogger = ({
  eventFeature,
  eventPathNames: eventPathNamesFromProps
} = {}) => {
  const { eventFeature: eventFeatureFromContext } = useEventFeatureBoundary();
  const { eventPathNames: eventPathNamesFromContext } = useEventPathBoundary();
  const feature = eventFeature ?? eventFeatureFromContext;
  const eventPathNames = eventPathNamesFromProps ?? eventPathNamesFromContext;
  const ctx = useLoggerContext();
  const {
    logger,
    defaultEventProperties: defaultEventPropertiesRaw,
    referrerUrl,
    flexUTMs
  } = ctx;
  const eventPath = useMemo(() => eventPathNames.join("/"), [eventPathNames]);
  const eventPropertiesFromBoundaryRaw = useContext(EventPropertyContext);
  const defaultEventProperties = useReferenceSafeObject(
    defaultEventPropertiesRaw
  );
  const eventPropertiesFromBoundary = useReferenceSafeObject(
    eventPropertiesFromBoundaryRaw
  );
  const click = useCallback(
    (action, eventProperties) => {
      logger.sendEvent({
        action,
        page: feature,
        eventProperties: {
          ...flexUTMs,
          ...defaultEventProperties,
          ...eventPropertiesFromBoundary,
          ...eventProperties,
          eventPath,
          currentUrl: window.location.pathname,
          referrerUrl,
          logVersion
        },
        actionType: ActionType.Click
      });
    },
    [
      defaultEventProperties,
      feature,
      eventPath,
      eventPropertiesFromBoundary,
      logger,
      referrerUrl,
      flexUTMs
    ]
  );
  const view = useCallback(
    (eventProperties) => {
      logger.sendEvent({
        page: feature,
        eventProperties: {
          ...flexUTMs,
          ...defaultEventProperties,
          ...eventPropertiesFromBoundary,
          ...eventProperties,
          eventPath,
          currentUrl: window.location.pathname,
          referrerUrl,
          logVersion
        },
        actionType: ActionType.View
      });
    },
    [
      defaultEventProperties,
      feature,
      eventPath,
      eventPropertiesFromBoundary,
      logger,
      referrerUrl,
      flexUTMs
    ]
  );
  const impression = useCallback(
    (action, eventProperties) => {
      logger.sendEvent({
        action,
        page: feature,
        eventProperties: {
          ...flexUTMs,
          ...defaultEventProperties,
          ...eventPropertiesFromBoundary,
          ...eventProperties,
          eventPath,
          currentUrl: window.location.pathname,
          referrerUrl,
          logVersion
        },
        actionType: ActionType.Impression
      });
    },
    [
      defaultEventProperties,
      feature,
      eventPath,
      eventPropertiesFromBoundary,
      logger,
      referrerUrl,
      flexUTMs
    ]
  );
  return {
    view,
    click,
    impression,
    setUserProperties: logger.setUserProperties,
    getConfig: logger.getConfig
  };
};

export { useEventLogger };
//# sourceMappingURL=useEventLogger.mjs.map
